<template>
  <span class="emoji__item"
        @click="$emit('click', {emoji, emojiName})"
        :title="emojiName">
    {{ emoji }}
  </span>
</template>

<script>
export default {
  name: 'EmojiItem',
  props: {
    emoji: {
      type: String,
      required: true
    },
    emojiName: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.emoji__item {
  margin: 1px 2px;
  font-size: 24px;
  cursor: pointer;
  line-height: 32px;
  width: 34px;
  text-align: center;

  &:hover {
    background: $buttonHoverBackgroundColor;
  }
}
</style>
